import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Anonimni_kontakt } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-anonimni-kontakt',
  templateUrl: './anonimni-kontakt.component.html',
  styleUrls: ['./anonimni-kontakt.component.scss']
})
export class AnonimniKontaktComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService, 
    private cdRef: ChangeDetectorRef, 
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#anonimniKontaktGrid' };
  isUserModerator: boolean = false;

  @ViewChild('anonimniKontaktGrid', { static: false }) anonimniKontaktGrid: DxDataGridComponent;

  ngOnInit() {
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
    this.loadData();
  }

  async loadData() {
    this.loading = true;
    
    try {
      const result = await this.apiClient.anonimniKontaktAll();
      this.gridData = result;

    } catch (error) {
      console.error('Error loading anonimni kontakt data:', error);
    } finally {
      this.loading = false;
    }
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const anonimniKontakt = e.row.data;

    try {
      await this.apiClient.anonimniKontaktDELETE(anonimniKontakt.id);

      const index = this.gridData.findIndex(item => item.id === anonimniKontakt.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting anonimni kontakt:', error);
    }
  }
}